import { z } from 'zod';
import { schemaActionInterventionReseau } from './interventions-reseau';
export const schemaActionTerrainReseau = schemaActionInterventionReseau.refine(
  (d) => ['accepter', 'commencer', 'bloquer', 'rapport'].includes(d.action),
  { message: 'Cette action ne peut pas être synchronisée depuis le terrain' },
);
export const schemaSynchronisationTerrainReseau = z
  .object({
    operation_id: z.string().uuid(),
    action: schemaActionTerrainReseau,
  })
  .strict();
export type ActionTerrainReseau = z.infer<typeof schemaActionTerrainReseau>;
export interface MissionTerrainReseau {
  id: string;
  titre: string;
  consignes: string;
  localisation: string;
  incident_reference: string;
  latitude?: number | null;
  longitude?: number | null;
  province_code?: string;
  province?: string;
  statut: string;
  version: number;
}
export interface TravailTerrainReseau {
  compte_id: string;
  organisation_id: string;
  appartenance_id: string;
  telecharge_le: string;
  expire_le: string;
  missions: MissionTerrainReseau[];
  articles: { id: string; reference: string; libelle: string; unite: string }[];
}
